<!-- eslint-disable max-len -->
<template>
  <div>
    <div class="relative pt-1 custome-progress">
      <div class="overflow-hidden h-1 mb-4 text-xs flex rounded bg-green-200">
        <div
          class="
            w-1/4
            shadow-none
            flex flex-col
            text-center
            whitespace-nowrap
            text-white
            justify-center
            bg-green-500
          "
        ></div>
      </div>
    </div>
    <div class="block relative mt-4 mb-4">
      <div class="block reltaive pl-4 pr-4">
        <h4
          class="
            block
            relative
            text-lgg
            font-bold
            text-darkgray
            mb-4
            text-center
          "
        >
          {{ $t("pages.name_check.heading") }}
        </h4>
        <p
          class="
            block
            relative
            text-sm text-darkgray1
            font-medium
            text-center
            mb-4
            pl-2.5
            pr-2.5
          "
        >
          {{ $t("pages.name_check.sub_heading") }}
        </p>
        <div class="block">
          <div class="form-group block relative mb-4">
            <label class="label_text text-xs block mb-1.5">
              {{ $t("pages.name_check.input.label") }}
            </label>
            <input
              v-model.trim="name"
              :class="{ error: error }"
              type="text"
              name=""
              class="placeholder-current form_control"
              :placeholder="$t('pages.common.buttons.dis72')"
              pattern="^[a-zA-Z]+$"
              @keyup="isLetter($event)"
              @keydown.space="(e) => e.preventDefault()"
              @input="$event.target.composing = false"
            />
            <span v-if="error" class="error-msg">
              {{ $t("pages.name_check.error") }}
            </span>
          </div>
          <div class="form-group block relative mb-4">
            <button
              :class="{ 'disabled:opacity-50': name.length < 3 }"
              class="
                w-full
                flex
                items-center
                justify-center
                btn_apply
                rounded-lg
                text-white
                btn_action
              "
              :disabled="name.length < 3"
              @click="submit"
            >
              {{ $t("pages.common.buttons.continue") }}
            </button>
          </div>

          <div class="social_signup_block block relative">
           

            <div class="form-group block relative mb-4">
              <label
                class="text text-info"
                @click="$router.push({ name: 'confirmCell' })"
              >
                {{ $t("pages.name_check.buttons.signup") }}
              </label>
            </div>

            <div class="form-group bg-white w-full">
              <label
                class="
                  text text-info text-info1
                  flex
                  items-center
                  justify-center
                "
                @click="$router.push({ name: 'RequestInformation' })"
              >
                <span class="icon">
                  <svg
                    width="20"
                    height="19"
                    viewBox="0 0 20 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.5 0.5C3.5625 0.5 2.76441 0.878567 2.25195 1.45508C1.7395 2.03159 1.5 2.77083 1.5 3.5C1.5 4.22917 1.7395 4.96841 2.25195 5.54492C2.76441 6.12143 3.5625 6.5 4.5 6.5C5.4375 6.5 6.23559 6.12143 6.74805 5.54492C7.2605 4.96841 7.5 4.22917 7.5 3.5C7.5 2.77083 7.2605 2.03159 6.74805 1.45508C6.23559 0.878567 5.4375 0.5 4.5 0.5ZM15.5 0.5C14.5625 0.5 13.7644 0.878567 13.252 1.45508C12.7395 2.03159 12.5 2.77083 12.5 3.5C12.5 4.22917 12.7395 4.96841 13.252 5.54492C13.7644 6.12143 14.5625 6.5 15.5 6.5C16.4375 6.5 17.2356 6.12143 17.748 5.54492C18.2605 4.96841 18.5 4.22917 18.5 3.5C18.5 2.77083 18.2605 2.03159 17.748 1.45508C17.2356 0.878567 16.4375 0.5 15.5 0.5ZM4.5 2C5.0625 2 5.38941 2.18393 5.62695 2.45117C5.8645 2.71841 6 3.10417 6 3.5C6 3.89583 5.8645 4.28159 5.62695 4.54883C5.38941 4.81607 5.0625 5 4.5 5C3.9375 5 3.61059 4.81607 3.37305 4.54883C3.1355 4.28159 3 3.89583 3 3.5C3 3.10417 3.1355 2.71841 3.37305 2.45117C3.61059 2.18393 3.9375 2 4.5 2ZM15.5 2C16.0625 2 16.3894 2.18393 16.627 2.45117C16.8645 2.71841 17 3.10417 17 3.5C17 3.89583 16.8645 4.28159 16.627 4.54883C16.3894 4.81607 16.0625 5 15.5 5C14.9375 5 14.6106 4.81607 14.373 4.54883C14.1355 4.28159 14 3.89583 14 3.5C14 3.10417 14.1355 2.71841 14.373 2.45117C14.6106 2.18393 14.9375 2 15.5 2ZM10 5.5C9.0625 5.5 8.26441 5.87857 7.75195 6.45508C7.2395 7.03159 7 7.77083 7 8.5C7 9.22917 7.2395 9.96841 7.75195 10.5449C8.26441 11.1214 9.0625 11.5 10 11.5C10.9375 11.5 11.7356 11.1214 12.248 10.5449C12.7605 9.96841 13 9.22917 13 8.5C13 7.77083 12.7605 7.03159 12.248 6.45508C11.7356 5.87857 10.9375 5.5 10 5.5ZM10 7C10.5625 7 10.8894 7.18393 11.127 7.45117C11.3645 7.71841 11.5 8.10417 11.5 8.5C11.5 8.89583 11.3645 9.28159 11.127 9.54883C10.8894 9.81607 10.5625 10 10 10C9.4375 10 9.11059 9.81607 8.87305 9.54883C8.6355 9.28159 8.5 8.89583 8.5 8.5C8.5 8.10417 8.6355 7.71841 8.87305 7.45117C9.11059 7.18393 9.4375 7 10 7ZM1.75 7.5C0.785 7.5 0 8.285 0 9.25V10.5C0 12.18 1.975 13.5 4.5 13.5H4.60547C4.83047 12.695 5.41969 12.0398 6.17969 11.7148C5.70469 11.8898 5.13 12 4.5 12C2.785 12 1.5 11.21 1.5 10.5V9.25C1.5 9.11 1.61 9 1.75 9H6.03027C6.01027 8.835 6 8.67 6 8.5C6 8.155 6.045 7.82 6.125 7.5H1.75ZM13.875 7.5C13.955 7.82 14 8.155 14 8.5C14 8.67 13.9897 8.835 13.9697 9H18.25C18.39 9 18.5 9.11 18.5 9.25V10.5C18.5 11.21 17.215 12 15.5 12C14.87 12 14.2953 11.8898 13.8203 11.7148C14.5803 12.0398 15.1695 12.695 15.3945 13.5H15.5C18.025 13.5 20 12.18 20 10.5V9.25C20 8.285 19.215 7.5 18.25 7.5H13.875ZM7.25 12.5C6.29252 12.5 5.5 13.2925 5.5 14.25V15.5C5.5 16.4591 6.13996 17.2406 6.96289 17.7344C7.78582 18.2281 8.84288 18.5 10 18.5C11.1571 18.5 12.2142 18.2281 13.0371 17.7344C13.86 17.2406 14.5 16.4591 14.5 15.5V14.25C14.5 13.2925 13.7075 12.5 12.75 12.5H7.25ZM7.25 14H12.75C12.8975 14 13 14.1025 13 14.25V15.5C13 15.7834 12.7999 16.1276 12.2656 16.4482C11.7313 16.7688 10.9139 17 10 17C9.08612 17 8.26869 16.7688 7.73438 16.4482C7.20006 16.1276 7 15.7834 7 15.5V14.25C7 14.1025 7.10248 14 7.25 14Z"
                      fill="#63B15B"
                    />
                  </svg>
                </span>
                {{ $t("pages.common.links.help") }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CheckLastname",
  data() {
    return {
      name: "",
      error: false,
      errorMsg: "",
    };
  },
  watch: {
    name: function (val) {
      // prettier-ignore
      const re = /[0-9]/ig;
      val = val.replaceAll(re, "");
      this.name = val;
      return val;
    },
  },
  methods: {
    submit() {
      this.$store.dispatch("user/verifyLastName", this.name).then((res) => {
        if (res) {
          this.error = false;
          this.errorMsg = "";
          this.$router.push({ name: "confirmCell" });
        } else {
          this.error = true;
        }
      });
    },
    isLetter(e) {
      this.error = false;
      this.errorMsg = "";
      const regex = /[0-9]/gi;
      return this.name.replaceAll(regex, "");
    },
  },
};
</script>

<style scoped>
.bg-green-500 {
  background: #63b15b;
}
.bg-green-200 {
  background: #e6f7e3;
}

.id_check_block {
  display: block;
  position: relative;

}



.social_signup_block {
  display: block;
  position: relative;
}

.social_signup_block .or_option {
  border-bottom: 2px solid #c6c6d1;
  display: block;
  text-align: center;
  line-height: 0;
  margin: 20px 0 20px;
}

.social_signup_block .or_option span {
  background: white;
  padding: 3px 12px;
}

.social_signup_block .form-group {
  display: block;
  margin: 0 0 15px;
}

.social_signup_block .form-group button {
  background: #f7f7f7;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  padding: 12px 14px;
  height: 46px;
  border-radius: 6px;
}

.social_signup_block .form-group .btn_facebook {
  color: #2a5ca4;
}

.social_signup_block .form-group button svg {
  width: 22px;
  height: 22px;
  margin-right: 13px;
}

.social_signup_block .form-group .btn_google {
  color: #f3423d;
}

.social_signup_block .form-group .text-info {
  text-align: center;
  display: block;
  font-size: 16px;
  font-weight: 500;
  color: #63b15b !important;
}

.social_signup_block .form-group .text-info a {
  color: #63b15b !important;
}

.social_signup_block .form-group .text-info .icon {
  margin-right: 8px;
}

.social_signup_block .form-group .text-info {
  margin-top: 30px;
}

.social_signup_block .form-group svg {
  display: inline;
}

.error-msg {
  width: 173px;
  height: 20px;
  left: 0;
  top: 184px;
  font-family: Quicksand, serif;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 154.5%;
  color: #ee5b64;
}

.error {
  border: 1px solid #ee5b64;
  box-sizing: border-box;
  border-radius: 4px;
}

/*-----------------------  Responsive code ------------------*/
/*-----------------------  Responsive code ------------------*/

input {
  height: 48px;
}

/*-----------------------  Responsive code ------------------*/
/*-----------------------  Responsive code ------------------*/
</style>
